module.exports = __webpack_public_path__ + "media/images/locations/h_1-e0792804464de165c598046585b49d3b.JPG";